
export const getDefaultState = () => {
  return {
    viewInfo: [],
    listDeletedRows: [],
    checkboxSelectedRows: [],
    cellsVersions: {
    },
    // Update (block and delay undoActions)
    // [projectId]: {
    //   [colId]: number
    // }
    updatingCols: {
    },
  };
};
export const state = getDefaultState();
